import { StyledDialogTitle, StyledDialogTitleContainer } from './styles';

type TDialogTitle = {
  children: React.ReactNode;
  rightSlot?: React.ReactNode;
};

export const DialogTitle = ({ children, rightSlot }: TDialogTitle) => {
  return (
    <StyledDialogTitleContainer
      direction="row"
      alignItems="center"
      justifyContent={rightSlot ? 'space-between' : 'center'}
      gap="20px"
    >
      <StyledDialogTitle variant="h3">{children}</StyledDialogTitle>
      {rightSlot}
    </StyledDialogTitleContainer>
  );
};
